import { useEffect, useState } from 'react';

import avatar from '../../img/avatar.svg';
import icons from '../../utils/icons';
import { getFBFormattedData, getGoogleFormattedData, getYelpFormattedData, getNumber } from '../../utils/functions';

import Image from '../single/Image';
import ProviderLogo from '../single/ProviderLogo';
import Name from '../single/Name';
import Rating from '../single/Rating';
import Time from '../single/Time';
import ReviewText from '../single/ReviewText';
import MiniMasonry from "minimasonry";


const Structure = ({ attributes, review, logo }) => {
    const { isProfileImg, isName, isTime, isIcon, isRatting, isDescription, showText } = attributes;
    const { name, photoUrl, reviewUrl, time, ratingIcon, reviewText } = review;

    return <div className="singleWrap masonrySingle">
        <div className="reviewCard">
            <Image isProfileImg={isProfileImg} url={photoUrl || avatar} name={name} />
            <div className="nameLogo">
                <Name isName={isName} url={reviewUrl} name={name} />
                <ProviderLogo isIcon={isIcon} icon={logo} />
            </div>
            <Time isTime={isTime} time={time} />
            <Rating isRatting={isRatting} stars={ratingIcon} />
            <ReviewText showText={showText} isDescription={isDescription} review_text={reviewText} />
        </div>
    </div>
}

const Masonry = ({ attributes, reviews }) => {
    const { cId, isReviewType, reviewPosition, ratingIconColors, columnGap, rowGap } = attributes;
    const { top, middle, bottom } = reviewPosition;
    const [btnClicked, setBtnClicked] = useState(null);

    useEffect(() => {
        const btns = document.querySelectorAll(`#grbbBusinessReview-${cId} .masonry .expandedBtn`);
        btns?.forEach(btn => {
            btn.addEventListener('click', function () {
                setBtnClicked(true);
                setTimeout(() => {
                    setBtnClicked(false)
                }, 50);
            })
        })
    }, [])

    useEffect(() => {
        const masonryEl = document.querySelector(`#grbbBusinessReview-${cId} .masonry`);

        setTimeout(() => {
            new MiniMasonry({
                container: masonryEl,
                gutterX: getNumber(columnGap),
                gutterY: getNumber(rowGap),
                minify: false,
                ultimateGutter: 5,
                surroundingGutter: true,
            });
        }, 0);
    }, [columnGap, rowGap, btnClicked]);

    const mainFunc = {
        facebook: (review, index) => <Structure key={index} attributes={attributes} review={getFBFormattedData(review, ratingIconColors.facebook)} logo={icons.facebook} />,

        google: (review, index) => <Structure key={index} attributes={attributes} review={getGoogleFormattedData(review, ratingIconColors.google)} logo={icons.google} />,

        yelp: (review, index) => <Structure key={index} attributes={attributes} review={getYelpFormattedData(review, ratingIconColors.yelp)} logo={icons.yelp} />
    }

    return <>
        {isReviewType[top] && reviews[top]?.map(mainFunc[top])}
        {isReviewType[middle] && reviews[middle]?.map(mainFunc[middle])}
        {isReviewType[bottom] && reviews[bottom]?.map(mainFunc[bottom])}
    </>
}

export default Masonry;